
import './../css/components/Cotactanos.css';

function Contactanos(){

    let sucursales = [
        {
            nombre: "Carrasco",
            telefono: "2600 24 77"
        },
        {
            nombre: "Pta. Carretas",
            telefono: "27109857"
        },
        {
            nombre: "Parque Miramar",
            telefono: "2605 77 20"
        },
        {
            nombre: "Geant",
            telefono: "2600 4881"
        }
    ]

    return(
        <section className="cont">
            <div className="cont__info">
                <p className="cont__info__texto">
                Estas buscando comunicarte con nosotros? Estaremos encantados de recibir tu mensaje. Recibirás una respuesta tan pronto como sea posible
                </p>
                <h1 className="cont__info__titulo">
                    Sucursales
                </h1>
                
                    {
                        sucursales.map((suc)=>
                           <div className="cont__info__sucursales"> 
                                <p className="cont__info_sucursales__nombre">
                                    {suc.nombre}
                                </p>
                                <p className="cont__info_sucursales__nombre">
                                    {suc.telefono}
                                </p>
                            </div>
                        )
                    }

                
            </div>
            <div className="cont__correo">
                <label className="cont__correo__label" for="nombre">
                Nombre
                </label>
                <input type="text" id ="nombre" className="cont__correo__campo"/>
                <label className="cont__correo__label" for="correo">
                Correo
                </label>
                <input type="text" id ="correo"  className="cont__correo__campo"/>
                <label className="cont__correo__label" for="mensaje">
                Mensaje
                </label>
                <textarea id ="mensaje"  className="cont__correo__campo" rows='10'/>
                <button  className="cont__correo__enviar">
                    ENVIAR
                </button>
            </div>
        </section>
    )
}

export default Contactanos;